import products from "../data/products.json";
import React, {useCallback, useState} from "react";
import aPHome from '../data/home_austattung_produkt.json';
import aPHomeEs from '../data/home_austattung_produkt_es.json';
import aPHomeNl from '../data/home_austattung_produkt_nl.json';
import aPKnx from '../data/knx_austattung_produkt.json';
import aPKnxEs from '../data/knx_austattung_produkt_es.json';
import aPKnxNl from '../data/knx_austattung_produkt_nl.json';
import aPkonv from '../data/konventionell_austattung_produkt.json';
import aPkonvEs from '../data/konventionell_austattung_produkt_es.json';
import aPkonvNl from '../data/konventionell_austattung_produkt_nl.json';
export default function CheckProducts() {
    let row = 0;
    return <div>
        <p><strong>Products.json</strong></p>
        <table>
            <thead>
                <tr>
                    <td></td>
                    <td>Artikelnummer</td>
                    <td>Home</td>
                    <td>KNX</td>
                    <td>Konventionell</td>
                </tr>
            </thead>
            <tbody>
            {(() => {
                // Initialize a row counter for this render pass
                let rowCount = 0;

                const stopIndex = products.findIndex(p => {
                    // Return true when you want to FORCE EXIT (stop including items)
                    // return p.Artikelnummer === '2336REGHZRHE';
                    // return true;
                    return false;
                });
                const activeProducts = stopIndex === -1 ? products : products.slice(0, stopIndex + 1);
                // console.log('activeProducts', activeProducts)

                return activeProducts.map((p) => {
                    const targetStr = p.Artikelnummer?.toString().trim().toLowerCase();

                    const foundHome = aPHome.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                    const foundHomeEs = aPHomeEs.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                    const foundHomeNl = aPHomeNl.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                    const foundKnx = aPKnx.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                    const foundKnxEs = aPKnxEs.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                    const foundKnxNl = aPKnxNl.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                    const foundKonv = aPkonv.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                    const foundKonvEs = aPkonvEs.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                    const foundKonvNl = aPkonvNl.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));

                    // console.log('row', p.Artikelnummer, foundHome, foundKnx, foundKonv, foundHomeEs, foundKnxEs, foundKonvEs, foundHomeNl, foundKnxNl, foundKonvNl)

                    // Only display the row if it's NOT found in any of the arrays
                    if (!foundKonv && !foundHome && !foundKnx && !foundKonvEs && !foundHomeEs && !foundKnxEs && !foundKonvNl && !foundHomeNl && !foundKnxNl) {
                        rowCount += 1;

                        return (
                            <tr key={p.Artikelnummer}>
                                <td>{rowCount}</td>
                                <td>{p.Artikelnummer}</td>
                                <td>{foundHome || foundHomeEs || foundHomeNl ? '1' : '0'}</td>
                                <td>{foundKnx || foundKnxEs || foundKnxNl ? '1' : '0'}</td>
                                <td>{foundKonv || foundKonvEs || foundKonvNl ? '1' : '0'}</td>
                            </tr>
                        );
                    }

                    // Explicitly return null if the product is filtered out
                    return null;
                });
            })()}
            </tbody>
        </table>
        <p><strong>Knx</strong></p>
        <table>
            <thead>
                <tr>
                    <td></td>
                    <td>Artikelnummer</td>
                    <td>Products.json</td>
                </tr>
            </thead>
            <tbody>
            {(() => {
                // Initialize a row counter for this render pass
                let rowCount = 0;
                const allKnx = [...aPKnx, ...aPKnxEs, ...aPKnxNl];

                const stopIndex = products.findIndex(p => {
                    // Return true when you want to FORCE EXIT (stop including items)
                    // return p.Artikelnummer === '2336REGHZRHE';
                    // return true;
                    return false;
                });
                const activeProducts = stopIndex === -1 ? allKnx : allKnx.slice(0, stopIndex + 1);
                // console.log('activeProducts', activeProducts)

                return activeProducts.map((p) => {
                    Object.keys(p).forEach((key) => {
                        const targetStr = p[key]?.toString().trim().toLowerCase();
                        const foundP = products.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                        if (!foundP) {
                            rowCount += 1;
                            return (
                                <tr key={p[key]}>
                                    <td>{rowCount}</td>
                                    <td>{p[key]}</td>
                                    <td>0</td>
                                </tr>
                            );
                        }
                    });
                    return null;
                });
            })()}
            </tbody>
        </table>
        <p><strong>Home</strong></p>
        <table>
            <thead>
                <tr>
                    <td></td>
                    <td>Artikelnummer</td>
                    <td>Products.json</td>
                </tr>
            </thead>
            <tbody>
            {(() => {
                // Initialize a row counter for this render pass
                let rowCount = 0;
                const allHome = [...aPHome, ...aPHomeEs, ...aPHomeNl];

                const stopIndex = products.findIndex(p => {
                    // Return true when you want to FORCE EXIT (stop including items)
                    // return p.Artikelnummer === '2336REGHZRHE';
                    // return true;
                    return false;
                });
                const activeProducts = stopIndex === -1 ? allHome : allHome.slice(0, stopIndex + 1);
                // console.log('activeProducts', activeProducts)

                return activeProducts.map((p) => {
                    Object.keys(p).forEach((key) => {
                        const targetStr = p[key]?.toString().trim().toLowerCase();
                        const foundP = products.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                        if (!foundP) {
                            rowCount += 1;
                            return (
                                <tr key={p[key]}>
                                    <td>{rowCount}</td>
                                    <td>{p[key]}</td>
                                    <td>0</td>
                                </tr>
                            );
                        }
                    });
                    return null;
                });
            })()}
            </tbody>
        </table>
        <p><strong>Konventionell</strong></p>
        <table>
            <thead>
                <tr>
                    <td></td>
                    <td>Artikelnummer</td>
                    <td>Products.json</td>
                </tr>
            </thead>
            <tbody>
            {(() => {
                // Initialize a row counter for this render pass
                let rowCount = 0;
                const allKonv = [...aPkonv, ...aPkonvEs, ...aPkonvNl];

                const stopIndex = products.findIndex(p => {
                    // Return true when you want to FORCE EXIT (stop including items)
                    // return p.Artikelnummer === '2336REGHZRHE';
                    // return true;
                    return false;
                });
                const activeProducts = stopIndex === -1 ? allKonv : allKonv.slice(0, stopIndex + 1);
                // console.log('activeProducts', activeProducts)

                return activeProducts.map((p) => {
                    Object.keys(p).forEach((key) => {
                        const targetStr = p[key]?.toString().trim().toLowerCase();
                        const foundP = products.some(item => JSON.stringify(item).toLowerCase().includes(targetStr));
                        // console.log('parsing', p, key, p[key], targetStr, foundP)
                        if (!foundP) {
                            rowCount += 1;
                            return (
                                <tr key={p[key]}>
                                    <td>{rowCount}</td>
                                    <td>{p[key]}</td>
                                    <td>0</td>
                                </tr>
                            );
                        }
                    });
                    return null;
                });
            })()}
            </tbody>
        </table>
        <p>Ready.</p>
    </div>
}
